export default __webpack_public_path__ + "static/media/ChevronRight.8417430e.svg";